import type { LeverandorBrukerRolle } from '@klp/formgenerator/interfaces';
import { useCallback } from 'react';
import i18n from 'i18next';

export const useRoleMapping = () => {
    const handleMapping = useCallback(
        (role?: LeverandorBrukerRolle | string) => {
            if (!role) return undefined;

            return role
                .split(',')
                .map((r) => i18n.t(`leverandor.table.roller.${r.trim()}`))
                .join(', ');
        },
        [],
    );

    return { handleMapping };
};
